module.exports = __webpack_public_path__ + "img/nova-ver3.a738a974.jpg";